var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1ad3a650f93dc88d9dcf6a6bd7f21810bd65c08c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-web@treefort-systems"]={id:"1ad3a650f93dc88d9dcf6a6bd7f21810bd65c08c"};
      